import { Typography } from '@atlas-metrics/design-system';
import React, { PropsWithChildren, useState } from 'react';

import Button from './buttons/Button';
import cutText from './utils/cutText';

export type Props = PropsWithChildren<{
  className?: string;
  toOpenText: string;
  toCloseText: string;
  value: string;
}>;

// approximately 8 lines of text on desktop
export const FREE_TEXT_MAX_LENGTH = 550;

const Accordion: React.FC<PropsWithChildren<Props>> = ({
  toOpenText,
  toCloseText,
  value,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <Typography
        variant='body-m'
        className='whitespace-pre-line text-ds-grey-700'
      >
        {!isExpanded ? `${cutText(value, FREE_TEXT_MAX_LENGTH - 150)}…` : value}
      </Typography>
      <Button
        onClick={toggleReadMore}
        variant='secondary-outline'
        text={isExpanded ? toCloseText : toOpenText}
        size='m'
        className='mt-[25px] w-fit rounded-xl normal-case'
      />
    </>
  );
};

export default Accordion;
